import React from 'react';
import ActionButton from 'components/Common/ActionButton';
import Box from '@material-ui/core/Box';
import MainCopyField from 'components/pages/ResourceSetting/Widgets/MainCopyField';

export default function DisabledForm() {
  return (
    <Box
      display="flex"
      flexDirection="column"
    >
      <Box marginBottom={3}>
        <MainCopyField disabled />
      </Box>
      <Box marginBottom={6} style={{ display: 'flex' }}>
        <ActionButton style={{ color: '#FFFFFF' }} disabled>
          儲存進度
        </ActionButton>
        <ActionButton style={{ color: '#FFFFFF' }} disabled>
          完成
        </ActionButton>
      </Box>
    </Box>
  );
}
